<template>
  <div class="prize">
    <div class="img">
      <img src="@/images/drawrule/prize.png" alt="" />
      <span>恭喜您中奖啦</span>
    </div>
    <main class="jiangpin">
      <div class="top_img">
        <img :src="imgUrl" alt="" />
      </div>
      <div class="fot_text">
        <div>恭喜您获得</div>
        <div style="margin-top:5px">
          <slot></slot>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  props: ["imgUrl"],
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.prize {
  box-sizing: border-box;
  padding: 15px;
  width: 260px;
  background: #ffffff;
  border-radius: 16px;
  .img {
    width: 100%;
    height: 44px;
    position: relative;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #6135be;
    img {
      width: 176px;
      height: 44px;
    }
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .jiangpin {
    text-align: center;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    .top_img {
      text-align: center;
      height: 110px;
      img {
        width: 160px;
        height: 100%;
      }
    }
    .fot_text {
      margin-top: 10px;
    }
  }
}
</style>
